module.exports = __webpack_public_path__ + "static/media/Tooth_icon_5117ee.de5f9972.svg";